import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Rectangle } from '@pixi/math';
import { MSAA_QUALITY } from '@pixi/constants';
var FilterState = /*#__PURE__*/function () {
  function FilterState() {
    _classCallCheck(this, FilterState);
    this.renderTexture = null;
    this.target = null;
    this.legacy = false;
    this.resolution = 1;
    this.multisample = MSAA_QUALITY.NONE;
    this.sourceFrame = new Rectangle();
    this.destinationFrame = new Rectangle();
    this.bindingSourceFrame = new Rectangle();
    this.bindingDestinationFrame = new Rectangle();
    this.filters = [];
    this.transform = null;
  }
  _createClass(FilterState, [{
    key: "clear",
    value: function clear() {
      this.target = null;
      this.filters = null;
      this.renderTexture = null;
    }
  }]);
  return FilterState;
}();
export { FilterState };